import { gql } from '@apollo/client';

export const ALL_USER_INSIGHTS = gql`
  query AllUserInsights($input: getInsightsInput!) {
    insights: allUserInsights(input: $input) {
      id
      name
      tags {
        id
        name
      }
      url
      description
      image
      isFavorite
      width
      height
    }
  }
`;
